export const PATIENT_FORM_DEFAULTS = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  phone: "",
  email: "",
  mrn: "",
  symptoms: [],
  otherSymptomDetails: "",
  notes: "",
  commercialInsuranceName: "",
  commercialInsuredName: "",
  commercialMemberId: "",
  commercialGroupNumber: "",
  autoCarrierName: "",
  autoPolicyNumber: "",
  autoClaimNumber: "",
  autoMedPayAmount: "",
  autoStateOfIssuance: "",
  autoTotalBenefit: "",
  autoUmAmount: "",
  autoAdjusterName: "",
  autoAdjusterPhone: "",
  autoAdjusterEmail: "",
  thirdPartyPremise: false,
  thirdPartyAuto: false,
  thirdPartyUmbrella: false,
  thirdPartyCarrierName: "",
  thirdPartyCoverage: "",
};

const WRITABLE_KEYS = Object.keys(PATIENT_FORM_DEFAULTS);

export function mergePatientWithFormDefaults(patient) {
  if (!patient) return null;
  return {
    ...PATIENT_FORM_DEFAULTS,
    ...patient,
    symptoms: Array.isArray(patient.symptoms) ? patient.symptoms : [],
    otherSymptomDetails: patient.otherSymptomDetails || "",
    thirdPartyPremise: !!patient.thirdPartyPremise,
    thirdPartyAuto: !!patient.thirdPartyAuto,
    thirdPartyUmbrella: !!patient.thirdPartyUmbrella,
  };
}

export function pickPatientWritableFields(source) {
  if (!source || typeof source !== "object") return {};
  const out = {};
  for (const key of WRITABLE_KEYS) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      out[key] = source[key];
    }
  }
  return out;
}
